import {memo} from 'react';
import {IconButton, InputAdornment, TextField, TextFieldVariants} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import i18n from 'i18n';

type SearchInputProps = {
    label?: string;
    value: string;
    onInput: (value: string) => void;
    width?: string;
    variant?: TextFieldVariants;
    size?: 'small' | 'medium';
    isFocus?: boolean;
    disabled?: boolean;
    setCollapsedInput?: (isCollapsedInput: boolean) => void;
    searchStyle?: object;
};
export const SearchInput = memo(
    ({
        value,
        onInput,
        label,
        variant = 'standard',
        width = '220px',
        size = 'medium',
        disabled = false,
        isFocus = false,
        setCollapsedInput,
        searchStyle,
    }: SearchInputProps) => {
        const defaultPlaceholder = i18n.t('search', {ns: 'common'});

        return (
            <TextField
                slotProps={{
                    inputLabel: {shrink: true},
                    input: {
                        startAdornment: (
                            <InputAdornment position='start'>
                                <SearchIcon />
                            </InputAdornment>
                        ),
                        endAdornment: value && (
                            <InputAdornment
                                sx={{cursor: 'pointer'}}
                                position='end'
                            >
                                <IconButton
                                    onClick={() => {
                                        onInput('');
                                        if (setCollapsedInput) {
                                            setCollapsedInput(true);
                                        }
                                    }}
                                >
                                    <CloseIcon fontSize='small' />
                                </IconButton>
                            </InputAdornment>
                        ),
                    },
                }}
                // eslint-disable-next-line
                autoFocus={isFocus}
                disabled={disabled}
                value={value}
                onChange={(e) => onInput(e.target.value)}
                sx={{
                    width,
                    ...searchStyle,
                }}
                size={size}
                placeholder={label || defaultPlaceholder}
                variant={variant}
            />
        );
    },
);
